
const Section = ({ children, className }) => {
  return <section className={`${className} lg:py-10 py-8`}>{children}</section>;
};

export default Section;
